module.exports = __webpack_public_path__ + "img/b9.82a94d41.png";